<template>
  <div class="posts-shortcuts">
    <div class="posts-shortcuts-title fade-in-anim-all fade-in-anim-all-hide">{{ title }}</div>
    <div class="posts-shortcuts-wrapper">
      <router-link
        :to="`/${item.type}/${item.slug}/`"
        class="post fade-in-anim-all fade-in-anim-all-hide"
        v-for="(item, index) in items"
        :key="index"
      >
        <div class="image-container">
          <div
            class="image"
            :style="`${item.image ? 'background-image: url(' + item.image + ')' : ''}`"
          ></div>
        </div>
        <div class="text">
          <div class="title">
            <span>{{ item.title }}</span>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "PostsShortcuts",
  props: {
    title: String,
    items: Array
  }
};
</script>

<style lang="scss">
.posts-shortcuts {
  margin-bottom: 100px;
  .posts-shortcuts-title {
    @include josefinsans-light;
    font-size: 24px;
    line-height: 1em;
    text-transform: uppercase;
    margin-bottom: 75px;
  }
  .posts-shortcuts-wrapper {
    .post {
      position: relative;
      display: flex;
      width: 100%;
      max-height: 150px;
      margin-bottom: 20px;
      overflow: hidden;
      &:hover {
        .image-container {
          filter: grayscale(100%);
        }
        &:before {
          transform: translateX(-10px);
        }
        &:after {
          transform: translateX(10px);
        }
        .text {
          .title {
            span {
              background-size: 100% 2px;
            }
          }
        }
      }
      &:before {
        content: "";
        position: absolute;
        top: 20%;
        left: 0;
        bottom: 20%;
        width: 80%;
        height: 60%;
        background: rgba(255, 255, 255, 0.1);
        transition: transform 0.3s;
      }
      &:after {
        content: "";
        position: absolute;
        top: 10%;
        left: 0;
        bottom: 10%;
        width: 60%;
        height: 80%;
        border: 1px solid rgba(255, 255, 255, 0.1);
        transition: transform 0.3s;
        transition-delay: 0.1s;
      }
      &:last-child {
        margin-bottom: 0;
      }
      .image-container {
        position: relative;
        width: 150px;
        height: 150px;
        margin-right: 15px;
        z-index: 1;
        transition: all 1s;
        .image {
          width: 100%;
          height: 100%;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center center;
          background-color: rgba(255, 255, 255, 0.1);
        }
      }
      .text {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 10px 0;
        z-index: 1;
        .title {
          @include josefinsans-regular;
          font-size: 16px;
          line-height: 1.2em;
          color: $pink;
          text-transform: uppercase;
          margin-bottom: 5px;
          span {
            text-decoration: none;
            background-image: linear-gradient(currentColor, currentColor);
            background-position: 0% 100%;
            background-repeat: no-repeat;
            background-size: 0% 2px;
            transition: background-size 0.3s;
            width:100%;
          }
        }
        .copy {
          @include opensans-light;
          font-size: 16px;
          line-height: 1.6em;
          max-height: 65px;
          overflow: hidden;
        }
      }
    }
  }
}
@media (max-width: $desktop) {
  .posts-shortcuts {
    .posts-shortcuts-title {
      margin-bottom: 50px;
    }
    .posts-shortcuts-wrapper {
      display: flex;
      flex-wrap: wrap;
      margin-left: -10px;
      margin-right: -10px;
      .post {
        flex-direction: column;
        max-width: calc(33.3333% - 20px);
        max-height: none;
        margin-left: 10px;
        margin-right: 10px;
        &:before,
        &:after {
          display: none;
        }
        .image-container {
          width: 100%;
          height: 200px;
          margin-right: 0;
          margin-bottom: 25px;
        }
        .text{          
          .title {
            text-align: center;
            
          }
        }
      }
    }
  }
}
@media (max-width: $tablet) {
  .posts-shortcuts {
    .posts-shortcuts-wrapper {
      .post {
        max-width: calc(50% - 20px);
      }
    }
  }
}
@media (max-width: $mobile) {
  .posts-shortcuts {
    .posts-shortcuts-wrapper {
      flex-direction: column;
      margin-left: 0;
      margin-right: 0;
      .post {
        max-width: 100%;
        margin-left: 0;
        margin-right: 0;
      }
    }
  }
}
</style>